import { useEffect, useRef } from "react";

interface Props {
  timeoutSeconds: number;
  onTimeout: () => void;
  enabled?: boolean;
}

const ACTIVITY_EVENTS = ["pointerdown", "keydown", "touchstart"] as const;

export function IdleTimer({
  timeoutSeconds,
  onTimeout,
  enabled = true,
}: Props) {
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const reset = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(onTimeout, timeoutSeconds * 1000);
    };

    reset();
    ACTIVITY_EVENTS.forEach((e) =>
      window.addEventListener(e, reset, { passive: true }),
    );

    return () => {
      if (timer.current) clearTimeout(timer.current);
      ACTIVITY_EVENTS.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [timeoutSeconds, onTimeout, enabled]);

  return null;
}
